var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { ApiProperty, ApiPropertyOptional, OmitType } from "@nestjs/swagger";
import { Transform, Type } from "class-transformer";
import { IsArray, IsBoolean, IsDate, IsEmail, IsEnum, IsNotEmpty, IsNumber, IsOptional, IsString, ValidateNested } from "class-validator";
import { AccountLinkingConflictDto } from "./account-linking.dtos";
import { AuthTarget } from "./clear.dtos";
import { ExternalResearcherOrganizationDto, ExternalResearcherOrganizationPublicProfileDto } from "./externalresearcherorganization.dtos";
import { ExternalResearcherUserDto } from "./externalresearcherorganizationuser.dtos";
import { GFIDProvider, HealthcareOrganizationDto, HealthcareOrganizationPatientFacingDto } from "./healthcareorganization.dtos";
import { HealthcareOrganizationUserDto } from "./healthcareorganizationuser.dtos";
import { HeapGlobalEventProperties } from "./heap.dtos";
import { BaseOrganizationDto } from "./organization.dtos";
import { PatientDto, ProxyAccessDto } from "./patient.dtos";
import { ServiceProviderOrganizationDto } from "./serviceproviderorganization.dtos";
import { ServiceProviderUserDto } from "./serviceprovideruser.dtos";
import { UserPermissions, UserType } from "./user.dtos";
export var SystemType;
(function (SystemType) {
    SystemType["CLOUD_BACKEND"] = "CLOUD_BACKEND";
    SystemType["AGENT"] = "AGENT";
    SystemType["AGENT_DEPLOY"] = "AGENT_DEPLOY";
})(SystemType || (SystemType = {}));
export var SpecialPurposeTokenType;
(function (SpecialPurposeTokenType) {
    SpecialPurposeTokenType["PASSWORD_RESET"] = "PASSWORD_RESET";
    SpecialPurposeTokenType["WELCOME"] = "WELCOME";
    SpecialPurposeTokenType["HX_TEST_PATIENT"] = "HX_TEST_PATIENT";
    SpecialPurposeTokenType["ACCOUNT_LINKING"] = "ACCOUNT_LINKING";
})(SpecialPurposeTokenType || (SpecialPurposeTokenType = {}));
export var AuthType;
(function (AuthType) {
    AuthType["USERNAME_PASSWORD"] = "USERNAME_PASSWORD";
    AuthType["SSO_SAML"] = "SSO_SAML";
})(AuthType || (AuthType = {}));
export class AuthTypeResponse {
}
__decorate([
    IsEnum(AuthType)
], AuthTypeResponse.prototype, "authType", void 0);
__decorate([
    IsString(),
    IsOptional()
], AuthTypeResponse.prototype, "redirectUrl", void 0);
__decorate([
    IsString(),
    IsOptional()
], AuthTypeResponse.prototype, "provider", void 0);
export class OrganizationLoginOption {
}
__decorate([
    IsString()
], OrganizationLoginOption.prototype, "id", void 0);
__decorate([
    IsString()
], OrganizationLoginOption.prototype, "name", void 0);
__decorate([
    IsString(),
    IsOptional()
], OrganizationLoginOption.prototype, "logoUrl", void 0);
__decorate([
    IsEnum(AuthType)
], OrganizationLoginOption.prototype, "authType", void 0);
__decorate([
    IsString(),
    IsOptional()
], OrganizationLoginOption.prototype, "ssoRedirectUrl", void 0);
export class OrganizationsForEmailInput {
}
__decorate([
    IsEmail()
], OrganizationsForEmailInput.prototype, "email", void 0);
__decorate([
    IsString(),
    IsOptional()
], OrganizationsForEmailInput.prototype, "redirectURL", void 0);
export class OrganizationsForEmailResponse {
}
__decorate([
    IsArray(),
    Type(() => OrganizationLoginOption),
    ValidateNested({ each: true })
], OrganizationsForEmailResponse.prototype, "organizations", void 0);
export var SystemPermissions;
(function (SystemPermissions) {
    SystemPermissions["QUERY"] = "QUERY";
    SystemPermissions["UPDATE"] = "UPDATE";
})(SystemPermissions || (SystemPermissions = {}));
export var ApiClientType;
(function (ApiClientType) {
    ApiClientType["API_HEALTHCARE_ORGANIZATION"] = "API_DATA_ORIGINATOR";
    ApiClientType["API_EXTERNAL_RESEARCHER"] = "API_EXTERNAL_RESEARCHER";
    ApiClientType["API_SERVICE_PROVIDER"] = "API_SERVICE_PROVIDER";
})(ApiClientType || (ApiClientType = {}));
export class AuthenticatedTokenHealthcareOrganization {
    constructor() {
        this.type = UserType.HEALTHCARE_ORGANIZATION;
    }
}
__decorate([
    IsEnum(UserType)
], AuthenticatedTokenHealthcareOrganization.prototype, "type", void 0);
__decorate([
    IsString()
], AuthenticatedTokenHealthcareOrganization.prototype, "userId", void 0);
__decorate([
    IsString()
], AuthenticatedTokenHealthcareOrganization.prototype, "organizationId", void 0);
__decorate([
    IsString()
], AuthenticatedTokenHealthcareOrganization.prototype, "mrn", void 0);
export class AuthenticatedTokenExternalResearchOrganization {
    constructor() {
        this.type = UserType.EXTERNAL_RESEARCHER;
    }
}
__decorate([
    IsEnum(UserType)
], AuthenticatedTokenExternalResearchOrganization.prototype, "type", void 0);
__decorate([
    IsString()
], AuthenticatedTokenExternalResearchOrganization.prototype, "userId", void 0);
__decorate([
    IsString()
], AuthenticatedTokenExternalResearchOrganization.prototype, "organizationId", void 0);
export function authenticatedUserOrganizationId(user) {
    if (user.type === UserType.PATIENT || user.type === UserType.PATIENT_READ_ONLY) {
        return null;
    }
    else if (user.type === SystemType.AGENT_DEPLOY || user.type === SystemType.CLOUD_BACKEND) {
        return null;
    }
    else {
        return user.organizationId;
    }
}
export function authenticatedUserInOrganization(user, organizationId) {
    return authenticatedUserOrganizationId(user) === organizationId;
}
export class AssociatedPatient {
}
__decorate([
    IsString()
], AssociatedPatient.prototype, "mrn", void 0);
export class AuthenticatedHealthcareOrganizationUserWithDetails extends HealthcareOrganizationUserDto {
    constructor() {
        super(...arguments);
        this.type = UserType.HEALTHCARE_ORGANIZATION;
    }
}
__decorate([
    Type(() => HealthcareOrganizationDto),
    ValidateNested()
], AuthenticatedHealthcareOrganizationUserWithDetails.prototype, "organization", void 0);
__decorate([
    Type(() => AssociatedPatient),
    IsOptional()
], AuthenticatedHealthcareOrganizationUserWithDetails.prototype, "associatedPatient", void 0);
__decorate([
    IsEnum(UserType)
], AuthenticatedHealthcareOrganizationUserWithDetails.prototype, "type", void 0);
export class AuthenticatedExternalResearcherUserWithDetails extends ExternalResearcherUserDto {
    constructor() {
        super(...arguments);
        this.type = UserType.EXTERNAL_RESEARCHER;
    }
}
__decorate([
    Type(() => ExternalResearcherOrganizationDto),
    ValidateNested()
], AuthenticatedExternalResearcherUserWithDetails.prototype, "organization", void 0);
__decorate([
    IsEnum(UserType)
], AuthenticatedExternalResearcherUserWithDetails.prototype, "type", void 0);
export class AuthenticatedServiceProviderUserWithDetails extends ServiceProviderUserDto {
    constructor() {
        super(...arguments);
        this.type = UserType.SERVICE_PROVIDER;
    }
}
__decorate([
    Type(() => ServiceProviderOrganizationDto),
    ValidateNested()
], AuthenticatedServiceProviderUserWithDetails.prototype, "organization", void 0);
__decorate([
    IsEnum(UserType)
], AuthenticatedServiceProviderUserWithDetails.prototype, "type", void 0);
export class AuthenticatedPatientDto extends PatientDto {
    constructor() {
        super(...arguments);
        this.type = UserType.PATIENT;
    }
}
__decorate([
    IsEnum(GFIDProvider),
    IsOptional()
], AuthenticatedPatientDto.prototype, "gfidProvider", void 0);
__decorate([
    Type(() => ProxyAccessDto),
    ValidateNested(),
    IsOptional()
], AuthenticatedPatientDto.prototype, "proxyAccess", void 0);
__decorate([
    IsEnum(UserType)
], AuthenticatedPatientDto.prototype, "type", void 0);
export class AuthenticatedHealthcareOrganizationWithDetails extends HealthcareOrganizationPatientFacingDto {
    constructor() {
        super(...arguments);
        this.type = UserType.HEALTHCARE_ORGANIZATION;
    }
}
__decorate([
    IsEnum(UserType)
], AuthenticatedHealthcareOrganizationWithDetails.prototype, "type", void 0);
__decorate([
    IsString()
], AuthenticatedHealthcareOrganizationWithDetails.prototype, "userId", void 0);
__decorate([
    IsString()
], AuthenticatedHealthcareOrganizationWithDetails.prototype, "organizationId", void 0);
__decorate([
    IsString()
], AuthenticatedHealthcareOrganizationWithDetails.prototype, "mrn", void 0);
export class AuthenticatedExternalResearcherOrganizationWithDetails extends ExternalResearcherOrganizationPublicProfileDto {
    constructor() {
        super(...arguments);
        this.type = UserType.EXTERNAL_RESEARCHER;
    }
}
__decorate([
    IsEnum(UserType)
], AuthenticatedExternalResearcherOrganizationWithDetails.prototype, "type", void 0);
__decorate([
    IsString()
], AuthenticatedExternalResearcherOrganizationWithDetails.prototype, "userId", void 0);
__decorate([
    IsString()
], AuthenticatedExternalResearcherOrganizationWithDetails.prototype, "organizationId", void 0);
export class AuthenticatedPatientWithDetails extends AuthenticatedPatientDto {
}
__decorate([
    IsBoolean(),
    IsOptional()
], AuthenticatedPatientWithDetails.prototype, "authenticatedWithIAL2", void 0);
__decorate([
    IsBoolean(),
    IsOptional()
], AuthenticatedPatientWithDetails.prototype, "isSandbox", void 0);
__decorate([
    IsBoolean(),
    IsOptional()
], AuthenticatedPatientWithDetails.prototype, "isTestPatient", void 0);
__decorate([
    IsBoolean(),
    IsOptional()
], AuthenticatedPatientWithDetails.prototype, "isFirstTimeLogin", void 0);
__decorate([
    Type(() => AccountLinkingConflictDto),
    ValidateNested(),
    IsOptional()
], AuthenticatedPatientWithDetails.prototype, "accountLinkingConflict", void 0);
__decorate([
    IsString(),
    IsOptional()
], AuthenticatedPatientWithDetails.prototype, "restrictedToOrgId", void 0);
export class AuthenticatedPatientReadOnlyWithDetails extends OmitType(AuthenticatedPatientDto, ["type"]) {
    constructor() {
        super(...arguments);
        this.type = UserType.PATIENT_READ_ONLY;
    }
}
__decorate([
    IsEnum(UserType)
], AuthenticatedPatientReadOnlyWithDetails.prototype, "type", void 0);
__decorate([
    IsBoolean(),
    IsOptional()
], AuthenticatedPatientReadOnlyWithDetails.prototype, "authenticatedWithIAL2", void 0);
__decorate([
    IsBoolean(),
    IsOptional()
], AuthenticatedPatientReadOnlyWithDetails.prototype, "isSandbox", void 0);
__decorate([
    IsString(),
    IsOptional()
], AuthenticatedPatientReadOnlyWithDetails.prototype, "restrictedToOrgId", void 0);
export class AuthenticationByPatientIdInput {
    constructor(fields) {
        Object.assign(this, fields);
    }
}
__decorate([
    IsString()
], AuthenticationByPatientIdInput.prototype, "patientId", void 0);
__decorate([
    IsString(),
    IsOptional()
], AuthenticationByPatientIdInput.prototype, "organizationName", void 0);
__decorate([
    IsString(),
    IsOptional()
], AuthenticationByPatientIdInput.prototype, "organizationId", void 0);
__decorate([
    IsBoolean(),
    IsOptional()
], AuthenticationByPatientIdInput.prototype, "sandboxMode", void 0);
export class AuthenticatedScreenshotUserWithDetails {
    constructor() {
        this.type = UserType.SCREENSHOT_USER;
    }
}
__decorate([
    IsString()
], AuthenticatedScreenshotUserWithDetails.prototype, "id", void 0);
__decorate([
    IsString()
], AuthenticatedScreenshotUserWithDetails.prototype, "firstName", void 0);
__decorate([
    IsString()
], AuthenticatedScreenshotUserWithDetails.prototype, "lastName", void 0);
__decorate([
    IsString()
], AuthenticatedScreenshotUserWithDetails.prototype, "organizationId", void 0);
__decorate([
    Type(() => BaseOrganizationDto, {
        discriminator: {
            property: "type",
            subTypes: [
                { value: HealthcareOrganizationDto, name: UserType.HEALTHCARE_ORGANIZATION },
                { value: ExternalResearcherOrganizationDto, name: UserType.EXTERNAL_RESEARCHER },
                { value: ServiceProviderOrganizationDto, name: UserType.SERVICE_PROVIDER },
            ],
        },
    }),
    ValidateNested()
], AuthenticatedScreenshotUserWithDetails.prototype, "organization", void 0);
__decorate([
    IsEnum(UserType)
], AuthenticatedScreenshotUserWithDetails.prototype, "type", void 0);
export class AuthenticatedAPIClient {
}
__decorate([
    IsString()
], AuthenticatedAPIClient.prototype, "apiKeyId", void 0);
__decorate([
    IsString()
], AuthenticatedAPIClient.prototype, "organizationId", void 0);
__decorate([
    IsEnum(ApiClientType)
], AuthenticatedAPIClient.prototype, "type", void 0);
__decorate([
    IsEnum(UserPermissions, { each: true })
], AuthenticatedAPIClient.prototype, "permissions", void 0);
export class AuthenticatedSpecialPurpose {
}
__decorate([
    IsString()
], AuthenticatedSpecialPurpose.prototype, "userId", void 0);
__decorate([
    IsString(),
    IsOptional()
], AuthenticatedSpecialPurpose.prototype, "organizationId", void 0);
__decorate([
    IsEnum(UserType)
], AuthenticatedSpecialPurpose.prototype, "type", void 0);
__decorate([
    IsEnum(SpecialPurposeTokenType)
], AuthenticatedSpecialPurpose.prototype, "specialPurposeType", void 0);
export class CreateUserInput {
}
__decorate([
    IsString()
], CreateUserInput.prototype, "email", void 0);
__decorate([
    IsString()
], CreateUserInput.prototype, "password", void 0);
__decorate([
    IsString()
], CreateUserInput.prototype, "organizationId", void 0);
__decorate([
    IsString()
], CreateUserInput.prototype, "phone", void 0);
__decorate([
    IsString()
], CreateUserInput.prototype, "name", void 0);
__decorate([
    IsString()
], CreateUserInput.prototype, "title", void 0);
__decorate([
    IsEnum(UserPermissions, { each: true })
], CreateUserInput.prototype, "permissions", void 0);
export class ForgotPasswordInput {
}
__decorate([
    IsString()
], ForgotPasswordInput.prototype, "email", void 0);
__decorate([
    IsString(),
    IsOptional()
], ForgotPasswordInput.prototype, "organizationId", void 0);
export class ResetPasswordInput {
}
__decorate([
    IsString()
], ResetPasswordInput.prototype, "password", void 0);
export class ChangePasswordInput {
}
__decorate([
    IsString()
], ChangePasswordInput.prototype, "email", void 0);
__decorate([
    IsString()
], ChangePasswordInput.prototype, "currentPassword", void 0);
__decorate([
    IsString()
], ChangePasswordInput.prototype, "password", void 0);
__decorate([
    IsString(),
    IsOptional()
], ChangePasswordInput.prototype, "reEnteredNewPassword", void 0);
__decorate([
    IsString(),
    IsOptional()
], ChangePasswordInput.prototype, "organizationId", void 0);
export var AuthTypeCheckInputType;
(function (AuthTypeCheckInputType) {
    AuthTypeCheckInputType["EMAIL"] = "EMAIL";
    AuthTypeCheckInputType["ORGANIZATION"] = "ORGANIZATION";
})(AuthTypeCheckInputType || (AuthTypeCheckInputType = {}));
export class AuthTypeCheckByEmailInput {
    constructor() {
        this.type = AuthTypeCheckInputType.EMAIL;
    }
}
__decorate([
    IsEnum(AuthTypeCheckInputType)
], AuthTypeCheckByEmailInput.prototype, "type", void 0);
__decorate([
    IsString()
], AuthTypeCheckByEmailInput.prototype, "email", void 0);
__decorate([
    IsString(),
    IsOptional()
], AuthTypeCheckByEmailInput.prototype, "redirectURL", void 0);
export class AuthTypeCheckByOrganizationInput {
    constructor() {
        this.type = AuthTypeCheckInputType.ORGANIZATION;
    }
}
__decorate([
    IsEnum(AuthTypeCheckInputType)
], AuthTypeCheckByOrganizationInput.prototype, "type", void 0);
__decorate([
    IsString()
], AuthTypeCheckByOrganizationInput.prototype, "organizationId", void 0);
__decorate([
    IsString(),
    IsOptional()
], AuthTypeCheckByOrganizationInput.prototype, "redirectURL", void 0);
export var AuthenticationInputType;
(function (AuthenticationInputType) {
    AuthenticationInputType["PASSWORD"] = "PASSWORD";
    AuthenticationInputType["CLEAR_IAL2"] = "CLEAR_IAL2";
    AuthenticationInputType["EXISTING_TOKEN"] = "EXISTING_TOKEN";
    AuthenticationInputType["TEST_PATIENT"] = "TEST_PATIENT";
    AuthenticationInputType["REFRESH_TOKEN"] = "REFRESH_TOKEN";
})(AuthenticationInputType || (AuthenticationInputType = {}));
export class AuthenticationByPasswordInput {
    constructor() {
        this.type = AuthenticationInputType.PASSWORD;
    }
}
__decorate([
    IsEnum(AuthenticationInputType)
], AuthenticationByPasswordInput.prototype, "type", void 0);
__decorate([
    IsString()
], AuthenticationByPasswordInput.prototype, "email", void 0);
__decorate([
    IsString()
], AuthenticationByPasswordInput.prototype, "password", void 0);
__decorate([
    IsString(),
    IsOptional()
], AuthenticationByPasswordInput.prototype, "organizationId", void 0);
export class AuthenticationByCLEARIAL2Input {
    constructor() {
        this.type = AuthenticationInputType.CLEAR_IAL2;
    }
}
__decorate([
    IsEnum(AuthenticationInputType)
], AuthenticationByCLEARIAL2Input.prototype, "type", void 0);
__decorate([
    IsString()
], AuthenticationByCLEARIAL2Input.prototype, "authCode", void 0);
__decorate([
    IsString()
], AuthenticationByCLEARIAL2Input.prototype, "redirectUri", void 0);
__decorate([
    IsString(),
    IsOptional()
], AuthenticationByCLEARIAL2Input.prototype, "organizationId", void 0);
__decorate([
    IsEnum(AuthTarget)
], AuthenticationByCLEARIAL2Input.prototype, "authTarget", void 0);
__decorate([
    IsBoolean()
], AuthenticationByCLEARIAL2Input.prototype, "sandboxMode", void 0);
__decorate([
    Type(() => HeapGlobalEventProperties),
    ValidateNested(),
    IsOptional()
], AuthenticationByCLEARIAL2Input.prototype, "heapGlobalEventProperties", void 0);
__decorate([
    IsString(),
    IsOptional()
], AuthenticationByCLEARIAL2Input.prototype, "linkingToken", void 0);
__decorate([
    IsString(),
    IsOptional()
], AuthenticationByCLEARIAL2Input.prototype, "existingAuthToken", void 0);
__decorate([
    Transform(({ value }) => (typeof value === "string" ? (value.trim() === "" ? undefined : value.trim()) : value)),
    IsEmail(),
    IsOptional()
], AuthenticationByCLEARIAL2Input.prototype, "collectedEmail", void 0);
export class AuthenticationByTestPatientInput {
    constructor() {
        this.type = AuthenticationInputType.TEST_PATIENT;
    }
}
__decorate([
    IsEnum(AuthenticationInputType)
], AuthenticationByTestPatientInput.prototype, "type", void 0);
__decorate([
    IsString()
], AuthenticationByTestPatientInput.prototype, "authCode", void 0);
__decorate([
    IsString()
], AuthenticationByTestPatientInput.prototype, "organizationId", void 0);
__decorate([
    IsString()
], AuthenticationByTestPatientInput.prototype, "hxTestToken", void 0);
export class AuthenticationByRefreshTokenInput {
    constructor() {
        this.type = AuthenticationInputType.REFRESH_TOKEN;
    }
}
__decorate([
    IsEnum(AuthenticationInputType)
], AuthenticationByRefreshTokenInput.prototype, "type", void 0);
__decorate([
    IsString(),
    IsOptional()
], AuthenticationByRefreshTokenInput.prototype, "refreshToken", void 0);
__decorate([
    IsNumber(),
    IsOptional()
], AuthenticationByRefreshTokenInput.prototype, "lastActivityAt", void 0);
__decorate([
    IsString(),
    IsOptional()
], AuthenticationByRefreshTokenInput.prototype, "unVerifiedUserId", void 0);
export class AuthenticationByGFIDPatientInput {
}
__decorate([
    IsString(),
    IsEnum(GFIDProvider)
], AuthenticationByGFIDPatientInput.prototype, "gfidProvider", void 0);
__decorate([
    IsString()
], AuthenticationByGFIDPatientInput.prototype, "gfid", void 0);
__decorate([
    IsString(),
    IsOptional()
], AuthenticationByGFIDPatientInput.prototype, "email", void 0);
__decorate([
    IsString(),
    IsOptional()
], AuthenticationByGFIDPatientInput.prototype, "givenName", void 0);
__decorate([
    IsString(),
    IsOptional()
], AuthenticationByGFIDPatientInput.prototype, "familyName", void 0);
__decorate([
    Type(() => Date),
    IsDate(),
    IsOptional()
], AuthenticationByGFIDPatientInput.prototype, "dateOfBirth", void 0);
__decorate([
    IsString(),
    IsOptional()
], AuthenticationByGFIDPatientInput.prototype, "phoneNumber", void 0);
__decorate([
    IsBoolean(),
    IsOptional()
], AuthenticationByGFIDPatientInput.prototype, "isPhoneVerified", void 0);
export class RefreshByCLEARIAL2Input {
    constructor() {
        this.type = AuthenticationInputType.CLEAR_IAL2;
    }
}
__decorate([
    IsEnum(AuthenticationInputType)
], RefreshByCLEARIAL2Input.prototype, "type", void 0);
__decorate([
    IsString()
], RefreshByCLEARIAL2Input.prototype, "patientId", void 0);
__decorate([
    IsEnum(AuthTarget)
], RefreshByCLEARIAL2Input.prototype, "authTarget", void 0);
export class TokenInputForTesting {
}
__decorate([
    IsString()
], TokenInputForTesting.prototype, "patientId", void 0);
export class PatientDemographicsAddress {
}
__decorate([
    IsArray(),
    IsOptional()
], PatientDemographicsAddress.prototype, "lines", void 0);
__decorate([
    IsString(),
    IsOptional()
], PatientDemographicsAddress.prototype, "city", void 0);
__decorate([
    IsString(),
    IsOptional()
], PatientDemographicsAddress.prototype, "district", void 0);
__decorate([
    IsString(),
    IsOptional()
], PatientDemographicsAddress.prototype, "state", void 0);
__decorate([
    IsString(),
    IsOptional()
], PatientDemographicsAddress.prototype, "postalCode", void 0);
__decorate([
    IsString(),
    IsOptional()
], PatientDemographicsAddress.prototype, "country", void 0);
export class PatientDemographics {
}
__decorate([
    IsString(),
    IsOptional(),
    IsNotEmpty()
], PatientDemographics.prototype, "familyName", void 0);
__decorate([
    IsString(),
    IsOptional(),
    IsNotEmpty()
], PatientDemographics.prototype, "givenName", void 0);
__decorate([
    IsString(),
    IsOptional(),
    IsNotEmpty()
], PatientDemographics.prototype, "birthDate", void 0);
__decorate([
    IsString(),
    IsOptional(),
    IsNotEmpty()
], PatientDemographics.prototype, "phone", void 0);
__decorate([
    IsString(),
    IsOptional(),
    IsNotEmpty()
], PatientDemographics.prototype, "email", void 0);
__decorate([
    Type(() => PatientDemographicsAddress),
    ValidateNested(),
    IsOptional()
], PatientDemographics.prototype, "address", void 0);
__decorate([
    IsBoolean(),
    IsOptional()
], PatientDemographics.prototype, "phoneVerified", void 0);
__decorate([
    IsString(),
    IsOptional(),
    IsNotEmpty()
], PatientDemographics.prototype, "avatarUrl", void 0);
export class AuthenticationByGFIDInput {
}
__decorate([
    IsString()
], AuthenticationByGFIDInput.prototype, "gfid", void 0);
__decorate([
    IsString(),
    IsEnum(GFIDProvider)
], AuthenticationByGFIDInput.prototype, "gfidProvider", void 0);
__decorate([
    IsString()
], AuthenticationByGFIDInput.prototype, "organizationId", void 0);
__decorate([
    Type(() => PatientDemographics),
    ValidateNested(),
    IsOptional()
], AuthenticationByGFIDInput.prototype, "demographics", void 0);
export class AuthenticationByExistingTokenInput {
    constructor() {
        this.type = AuthenticationInputType.EXISTING_TOKEN;
    }
}
__decorate([
    IsEnum(AuthenticationInputType)
], AuthenticationByExistingTokenInput.prototype, "type", void 0);
__decorate([
    IsString()
], AuthenticationByExistingTokenInput.prototype, "token", void 0);
export class AuthenticationByAPIKeyAndSecret {
}
__decorate([
    ApiProperty({ description: "API key for authentication" }),
    IsString()
], AuthenticationByAPIKeyAndSecret.prototype, "apiKey", void 0);
__decorate([
    ApiProperty({ description: "API secret for authentication" }),
    IsString()
], AuthenticationByAPIKeyAndSecret.prototype, "apiSecret", void 0);
export class AuthenticationByPatientCredentials {
}
__decorate([
    ApiProperty({ description: "Patient email address" }),
    IsString()
], AuthenticationByPatientCredentials.prototype, "email", void 0);
__decorate([
    ApiProperty({ description: "Patient password" }),
    IsString()
], AuthenticationByPatientCredentials.prototype, "password", void 0);
__decorate([
    ApiPropertyOptional({ description: "Optional project ID to include in the token (for MCP access)" }),
    IsString(),
    IsOptional()
], AuthenticationByPatientCredentials.prototype, "projectId", void 0);
export var LinkingStatus;
(function (LinkingStatus) {
    LinkingStatus["LINKED"] = "LINKED";
    LinkingStatus["ALREADY_LINKED"] = "ALREADY_LINKED";
})(LinkingStatus || (LinkingStatus = {}));
export class GenerateUserTokenResult {
}
__decorate([
    IsString()
], GenerateUserTokenResult.prototype, "token", void 0);
__decorate([
    IsNumber()
], GenerateUserTokenResult.prototype, "expiration", void 0);
__decorate([
    Type(() => Object, {
        discriminator: {
            property: "type",
            subTypes: [
                { value: AuthenticatedHealthcareOrganizationUserWithDetails, name: UserType.HEALTHCARE_ORGANIZATION },
                { value: AuthenticatedExternalResearcherUserWithDetails, name: UserType.EXTERNAL_RESEARCHER },
                { value: AuthenticatedServiceProviderUserWithDetails, name: UserType.SERVICE_PROVIDER },
                { value: AuthenticatedPatientWithDetails, name: UserType.PATIENT },
                { value: AuthenticatedPatientReadOnlyWithDetails, name: UserType.PATIENT_READ_ONLY },
                { value: AuthenticatedScreenshotUserWithDetails, name: UserType.SCREENSHOT_USER },
            ],
        },
    }),
    ValidateNested()
], GenerateUserTokenResult.prototype, "user", void 0);
__decorate([
    IsEnum(LinkingStatus),
    IsOptional()
], GenerateUserTokenResult.prototype, "linkingStatus", void 0);
__decorate([
    IsBoolean(),
    IsOptional()
], GenerateUserTokenResult.prototype, "isFirstTimeLogin", void 0);
__decorate([
    Type(() => AccountLinkingConflictDto),
    ValidateNested(),
    IsOptional()
], GenerateUserTokenResult.prototype, "accountLinkingConflict", void 0);
export class SwitchAccountResult {
}
__decorate([
    ApiProperty({ description: "ID of the CLEAR patient account" }),
    IsString()
], SwitchAccountResult.prototype, "clearPatientId", void 0);
__decorate([
    ApiProperty({ description: "New JWT token for the CLEAR patient" }),
    IsString()
], SwitchAccountResult.prototype, "token", void 0);
__decorate([
    ApiProperty({ description: "Token expiration timestamp" }),
    IsNumber()
], SwitchAccountResult.prototype, "expiration", void 0);
__decorate([
    ApiProperty({ description: "User details for the CLEAR patient" }),
    ValidateNested(),
    Type(() => AuthenticatedPatientWithDetails)
], SwitchAccountResult.prototype, "user", void 0);
export class GenerateSystemTokenResult {
}
__decorate([
    IsString()
], GenerateSystemTokenResult.prototype, "token", void 0);
__decorate([
    IsNumber()
], GenerateSystemTokenResult.prototype, "expiration", void 0);
export class GenerateAPITokenResult {
}
__decorate([
    ApiProperty(),
    IsString()
], GenerateAPITokenResult.prototype, "token", void 0);
__decorate([
    ApiProperty(),
    IsNumber()
], GenerateAPITokenResult.prototype, "expiration", void 0);
export class BaseTokenPayload {
}
__decorate([
    IsString()
], BaseTokenPayload.prototype, "iss", void 0);
__decorate([
    IsString()
], BaseTokenPayload.prototype, "sub", void 0);
__decorate([
    IsString()
], BaseTokenPayload.prototype, "aud", void 0);
__decorate([
    IsNumber()
], BaseTokenPayload.prototype, "iat", void 0);
__decorate([
    IsNumber()
], BaseTokenPayload.prototype, "exp", void 0);
__decorate([
    IsString()
], BaseTokenPayload.prototype, "jti", void 0);
__decorate([
    IsNumber(),
    IsOptional()
], BaseTokenPayload.prototype, "extendableExpiration", void 0);
__decorate([
    IsString()
], BaseTokenPayload.prototype, "type", void 0);
__decorate([
    IsString(),
    IsOptional()
], BaseTokenPayload.prototype, "organizationId", void 0);
__decorate([
    IsString(),
    IsOptional()
], BaseTokenPayload.prototype, "applicationId", void 0);
__decorate([
    IsString(),
    IsOptional()
], BaseTokenPayload.prototype, "specialPurposeType", void 0);
__decorate([
    IsBoolean(),
    IsOptional()
], BaseTokenPayload.prototype, "irtwe", void 0);
export class AuthTokenPayload extends OmitType(BaseTokenPayload, ["type", "organizationId", "applicationId", "specialPurposeType"]) {
}
__decorate([
    IsString(),
    IsOptional()
], AuthTokenPayload.prototype, "email", void 0);
__decorate([
    IsString({ each: true }),
    IsEnum(UserPermissions, { each: true })
], AuthTokenPayload.prototype, "permissions", void 0);
__decorate([
    IsString(),
    IsEnum(UserType)
], AuthTokenPayload.prototype, "type", void 0);
__decorate([
    IsString(),
    IsOptional()
], AuthTokenPayload.prototype, "organizationId", void 0);
__decorate([
    IsString(),
    IsOptional()
], AuthTokenPayload.prototype, "state", void 0);
__decorate([
    IsString(),
    IsOptional()
], AuthTokenPayload.prototype, "firstName", void 0);
__decorate([
    IsString(),
    IsOptional()
], AuthTokenPayload.prototype, "lastName", void 0);
__decorate([
    Type(() => Date),
    IsDate(),
    IsOptional()
], AuthTokenPayload.prototype, "createdAt", void 0);
__decorate([
    IsString(),
    IsEnum(GFIDProvider),
    IsOptional()
], AuthTokenPayload.prototype, "gfidProvider", void 0);
__decorate([
    Type(() => ProxyAccessDto),
    ValidateNested(),
    IsOptional()
], AuthTokenPayload.prototype, "proxyAccess", void 0);
__decorate([
    IsArray(),
    Type(() => Object, {
        discriminator: {
            property: "type",
            subTypes: [
                { value: AuthenticatedTokenHealthcareOrganization, name: UserType.HEALTHCARE_ORGANIZATION },
                { value: AuthenticatedTokenExternalResearchOrganization, name: UserType.EXTERNAL_RESEARCHER },
            ],
        },
    }),
    ValidateNested({ each: true }),
    IsOptional()
], AuthTokenPayload.prototype, "authenticatedOrganizations", void 0);
__decorate([
    IsString(),
    IsOptional()
], AuthTokenPayload.prototype, "projectId", void 0);
__decorate([
    IsBoolean(),
    IsOptional()
], AuthTokenPayload.prototype, "authenticatedWithIAL2", void 0);
__decorate([
    IsString(),
    IsOptional()
], AuthTokenPayload.prototype, "mrn", void 0);
__decorate([
    IsBoolean(),
    IsOptional()
], AuthTokenPayload.prototype, "isTestPatient", void 0);
__decorate([
    IsString(),
    IsOptional()
], AuthTokenPayload.prototype, "restrictedToOrgId", void 0);
export class APITokenPayload extends OmitType(BaseTokenPayload, ["type", "organizationId", "applicationId", "specialPurposeType"]) {
}
__decorate([
    IsString()
], APITokenPayload.prototype, "organizationId", void 0);
__decorate([
    IsEnum(ApiClientType)
], APITokenPayload.prototype, "type", void 0);
__decorate([
    IsString({ each: true }),
    IsEnum(UserPermissions, { each: true })
], APITokenPayload.prototype, "permissions", void 0);
export class SystemAuthTokenPayload extends OmitType(BaseTokenPayload, ["type", "organizationId", "applicationId", "specialPurposeType"]) {
}
__decorate([
    IsEnum(SystemPermissions, { each: true }),
    IsOptional()
], SystemAuthTokenPayload.prototype, "permissions", void 0);
__decorate([
    IsString({ each: true }),
    IsEnum(SystemType, { each: true })
], SystemAuthTokenPayload.prototype, "type", void 0);
__decorate([
    IsString(),
    IsOptional()
], SystemAuthTokenPayload.prototype, "organizationId", void 0);
__decorate([
    IsString(),
    IsOptional()
], SystemAuthTokenPayload.prototype, "applicationId", void 0);
__decorate([
    IsString(),
    IsOptional()
], SystemAuthTokenPayload.prototype, "version", void 0);
export class SpecialPurposeTokenPayload extends OmitType(BaseTokenPayload, [
    "type",
    "organizationId",
    "applicationId",
    "specialPurposeType",
]) {
}
__decorate([
    IsString(),
    IsOptional()
], SpecialPurposeTokenPayload.prototype, "organizationId", void 0);
__decorate([
    IsString(),
    IsEnum(UserType)
], SpecialPurposeTokenPayload.prototype, "type", void 0);
__decorate([
    IsString({ each: true }),
    IsEnum(SpecialPurposeTokenType, { each: true })
], SpecialPurposeTokenPayload.prototype, "specialPurposeType", void 0);
export class PublicKey {
}
__decorate([
    IsString(),
    IsOptional()
], PublicKey.prototype, "kid", void 0);
__decorate([
    IsString(),
    IsOptional()
], PublicKey.prototype, "kty", void 0);
__decorate([
    IsString(),
    IsOptional()
], PublicKey.prototype, "e", void 0);
__decorate([
    IsString(),
    IsOptional()
], PublicKey.prototype, "use", void 0);
__decorate([
    IsString(),
    IsOptional()
], PublicKey.prototype, "alg", void 0);
__decorate([
    IsString(),
    IsOptional()
], PublicKey.prototype, "n", void 0);
export class PatientTEFCAAuthInfoDto {
}
__decorate([
    IsBoolean()
], PatientTEFCAAuthInfoDto.prototype, "ial2Authorized", void 0);
__decorate([
    IsBoolean()
], PatientTEFCAAuthInfoDto.prototype, "ial2Expired", void 0);
export class HigherAuthTierRequiredError extends Error {
    constructor(patientId, email, requiredProviders) {
        super(`Patient ${patientId} has stronger authentication (${requiredProviders.join(", ")}); this method cannot enter the account.`);
        this.patientId = patientId;
        this.email = email;
        this.requiredProviders = requiredProviders;
        this.name = "HigherAuthTierRequiredError";
    }
}
export class LinkAccountInput {
}
__decorate([
    IsString()
], LinkAccountInput.prototype, "linkingToken", void 0);
export class LinkAccountResult {
}
__decorate([
    IsBoolean()
], LinkAccountResult.prototype, "success", void 0);
__decorate([
    IsEnum(LinkingStatus),
    IsOptional()
], LinkAccountResult.prototype, "linkingStatus", void 0);
export class LinkingTokenPayload extends OmitType(BaseTokenPayload, ["type", "organizationId", "applicationId", "specialPurposeType"]) {
}
__decorate([
    IsString(),
    IsEnum(UserType)
], LinkingTokenPayload.prototype, "type", void 0);
__decorate([
    IsString({ each: true }),
    IsEnum(SpecialPurposeTokenType, { each: true })
], LinkingTokenPayload.prototype, "specialPurposeType", void 0);
__decorate([
    IsString()
], LinkingTokenPayload.prototype, "gfid", void 0);
__decorate([
    IsString(),
    IsEnum(GFIDProvider)
], LinkingTokenPayload.prototype, "gfidProvider", void 0);
__decorate([
    IsString()
], LinkingTokenPayload.prototype, "email", void 0);
export class AuthenticatedLinkingToken {
}
__decorate([
    IsString()
], AuthenticatedLinkingToken.prototype, "patientId", void 0);
__decorate([
    IsString()
], AuthenticatedLinkingToken.prototype, "gfid", void 0);
__decorate([
    IsString(),
    IsEnum(GFIDProvider)
], AuthenticatedLinkingToken.prototype, "gfidProvider", void 0);
__decorate([
    IsString()
], AuthenticatedLinkingToken.prototype, "email", void 0);
__decorate([
    IsEnum(SpecialPurposeTokenType)
], AuthenticatedLinkingToken.prototype, "specialPurposeType", void 0);
export class LogoutInput {
}
__decorate([
    IsBoolean(),
    IsOptional(),
    ApiPropertyOptional()
], LogoutInput.prototype, "voluntary", void 0);
